import { DropdownOptionType } from "../types";

const months = {
  January: "01",
  February: "02",
  March: "03",
  April: "04",
  May: "05",
  June: "06",
  July: "07",
  August: "08",
  September: "09",
  October: "10",
  November: "11",
  December: "12",
} as const;

type MonthKeys = keyof typeof months;

export function getMonthNumber(monthName: MonthKeys): string | undefined {
  return months[monthName];
}

export function getYearData(upto = 20, startYear?: number | undefined) {
  if (startYear === undefined) {
    let date = new Date();
    startYear = date.getFullYear();
  }
  const yearData: DropdownOptionType[] = [];
  for (let i = 0; i < upto; i++) {
    yearData.push({
      id: i,
      text: `${startYear - i}`,
    });
  }
  return yearData;
}
